import { useQuery } from "@tanstack/react-query";

import { listMyTimeEntries } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { TimeEntry, WeekRange } from "../types";
import { toTimeEntry } from "../utils/map";

export function useMyTimeEntries(range: WeekRange, enabled = true) {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["time-entries", "me", activeCanteiroId, range.from, range.to],
		enabled: enabled && activeCanteiroId != null,
		queryFn: async (): Promise<TimeEntry[]> => {
			const { items } = await listMyTimeEntries(activeCanteiroId as string, {
				from: range.from,
				to: range.to,
			});
			return items.map(toTimeEntry);
		},
		staleTime: 30_000,
	});
}
